import type { EntityType } from '@localagent/sdk';

export interface EntityTypeLabel {
  singular: string;
  plural: string;
  icon: string;
}

export const ENTITY_TYPE_LABELS: Record<EntityType, EntityTypeLabel> = {
  workspace: { singular: 'Workspace', plural: 'Workspaces', icon: '📁' },
  team: { singular: 'Team', plural: 'Teams', icon: '👥' },
  project: { singular: 'Project', plural: 'Projects', icon: '📋' },
  initiative: { singular: 'Initiative', plural: 'Initiatives', icon: '🎯' },
  ticket: { singular: 'Ticket', plural: 'Tickets', icon: '🎫' },
  persona: { singular: 'Persona', plural: 'Personas', icon: '🤖' },
  automation: { singular: 'Automation', plural: 'Automations', icon: '⚙️' },
  integration: { singular: 'Connection', plural: 'Connections', icon: '🔌' },
  tool_endpoint: { singular: 'Tool', plural: 'Tools', icon: '🔧' },
  session: { singular: 'Session', plural: 'Sessions', icon: '💬' },
  agent_process: { singular: 'Process', plural: 'Processes', icon: '🔀' },
  session_message: { singular: 'Session message', plural: 'Session messages', icon: '💬' },
  session_event: { singular: 'Session activity', plural: 'Session activity', icon: '⚡' },
  file: { singular: 'File', plural: 'Files', icon: '📄' },
  directory: { singular: 'Directory', plural: 'Directories', icon: '📂' },
  feed_post: { singular: 'Post', plural: 'Posts', icon: '📣' },
  account_skill: { singular: 'Skill', plural: 'Skills', icon: '✦' },
  account_artifact: { singular: 'Artifact', plural: 'Artifacts', icon: '🖼' },
  account_secret: { singular: 'Secret', plural: 'Secrets', icon: '🔑' },
};
